export default __webpack_public_path__ + "static/media/07.f433ec4c.jpg";